export default "__VITE_PUBLIC_ASSET__1023d4dc__"